import type { IssueEntity } from 'serviceWorker/repository/issue/entity';
import {
  ISSUE_CHART_FILTER_KINDS,
  IssueChartFilterKind,
  readIssueChartFilterValues,
} from 'shared/domain/analytics/issueChartFilters';
import type { FilterValues, IssueChart } from 'shared/types/analytics';
import {
  filterByAssignee,
  filterByDateRange,
  filterByImpact,
  filterByProcess,
  filterBySite,
  filterBySubcontractor,
  filterByWorktype,
  MultiselectFilter,
} from './seriesCreation';

/** How each kind of filter checks an issue; nothing chosen lets every issue pass. */
const FILTER_ISSUE_BY_KIND: Readonly<Record<IssueChartFilterKind, MultiselectFilter<IssueEntity>>> = {
  [IssueChartFilterKind.originators]: filterBySubcontractor,
  [IssueChartFilterKind.process]: filterByProcess,
  [IssueChartFilterKind.sites]: filterBySite,
  [IssueChartFilterKind.workType]: filterByWorktype,
  [IssueChartFilterKind.impact]: filterByImpact,
  [IssueChartFilterKind.assignee]: filterByAssignee,
};

/** Issues detected in the chosen date range that match every filter the chart sent. */
export function filterIssuesByChartFilters(
  issues: IssueEntity[],
  chart: IssueChart,
  filters: FilterValues,
  timezone: string
): IssueEntity[] {
  const { dateRange, selectedIds } = readIssueChartFilterValues(chart, filters);
  const kinds = ISSUE_CHART_FILTER_KINDS[chart];

  return issues.filter(
    (issue) =>
      filterByDateRange(dateRange, issue.primaryData.detectionDate || issue.createdAt, timezone) &&
      kinds.every((kind) => FILTER_ISSUE_BY_KIND[kind](selectedIds[kind], issue))
  );
}
